




import Vue from 'vue';
import NumInput from './NumInput.vue';

export default Vue.extend({
  name: 'el-num',
  components: {
    NumInput,
  },
  props: {
    elNum: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
});
